export default __webpack_public_path__ + "static/telecom-industry-cta-9dd7b10cd2e6f00c5d6f837db55d0a1c.webp";